import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { useIntl } from 'react-intl';
import { handleResponseStatus, sendRequest } from '../../../../utils/api-request';
import { getAllZones, getRemainingZones } from '../../../../utils/helpers';
import getConfig from '../../../../config';
import TableHeaderElement from '../../../../generic/TableHeaderElement/TableHeaderElement';
import Loader from '../../../../components/Loader/Loader';
import CustomBtn from '../../../../generic/CustomBtn/CustomBtn';
import ProjectSampleZone from '../ProjectSampleZone/ProjectSampleZone';
import AssignAgentPopUp from '../../../../components/PopUp/AssignFieldAgent';
import { sortData } from '../../../../utils/sort';
import { appStore } from '../../../../state/app';
import DeleteFieldAgent from '../../../../components/PopUp/DeleteFieldAgent';

const { backendApi } = getConfig();

const ProjectFieldAgents = ({ data, setShowRequestModal, isProjectFinished }) => {
  const [projectData, setProjectData] = useState({});
  const [simpleZoneInfo, setSimpleZoneInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [assignAgentPopUp, setAssignAgentPopUp] = useState(false);
  const [isDisabledAction, setIsDisabledAction] = useState(false);
  const [deleteAgentPopUp, setDeleteAgentPopUp] = useState(false);

  const [deleteInfo, setDeleteInfo] = useState({});

  const { state } = useContext(appStore);
  const { app } = state;
  const translate = useIntl();

  useEffect(async () => {
    if (data?.sampleZones?.length) {
      const { statusCode, result } = await sendRequest(`${backendApi}/api/dashboard/sample-zone/list`, 'GET', {}, true);

      handleResponseStatus(
        statusCode,
        () => {
          const updProjectData = { ...data };
          for (const [i, sz] of Object.entries(updProjectData.sampleZones)) {
            const target = result?.find((szM) => szM.project_id === updProjectData.project_id && szM.sample_zone_id === sz.id && szM?.field_agent_id);
            updProjectData.sampleZones[i].assign = !!target;
            updProjectData.sampleZones[i].field_agent_name = target ? target.field_agent_name : '';
            updProjectData.sampleZones[i].field_agent_id = target ? target.field_agent_id : '';
            updProjectData.sampleZones[i].field_agent_email = target ? target.field_agent_email : '';
          }
          setProjectData(updProjectData);
          setLoading(false);
        },
        () => {
          setLoading(false);
          setShowRequestModal(true);
        },
      );
    }
    setIsDisabledAction(isProjectFinished);
    setLoading(false);
  }, [app.allFa]);

  if (loading) {
    return (
      <div className="dashboard__loader">
        <Loader />
      </div>
    );
  }

  const projectDataSort = (sortName, sortAscDesc) => {
    const resSort = sortData(projectData.sampleZones, sortName, sortAscDesc);
    return setProjectData(
      {
        ...projectData,
        sampleZones: resSort,
      },
    );
  };

  return (
    <>
      {projectData?.sampleZones?.length ? (
        <div className="project__field-agents">
          <div className="sample-zones__header">
            <div className="sample-zones__header-block" />
            <div className="sample-zones__header-block">
              <TableHeaderElement
                params={{
                  projectDataSort,
                  sortName: 'field_agent_name',
                  value: translate.formatMessage({ id: 'fieldAgents.name' }),
                }}
              />
            </div>
            <div className="sample-zones__header-block">
              <TableHeaderElement
                params={{
                  projectDataSort,
                  sortName: 'field_agent_email',
                  value: translate.formatMessage({ id: 'fieldAgents.email' }),
                }}
              />
            </div>
            <div className="sample-zones__header-action">
              <TableHeaderElement
                params={{
                  value: translate.formatMessage({ id: 'fieldAgents.action' }),
                }}
              />
            </div>
          </div>
          <div className="sample-zones__list overflow-scroll">
            {projectData.sampleZones.map((sz) => <ProjectSampleZone data={sz} setDeleteInfo={setDeleteInfo} setDeleteAgentPopUp={setDeleteAgentPopUp} deleteAgentPopUp={deleteAgentPopUp} key={sz.sampleName} projectId={projectData.project_id} isDisabledAction={isDisabledAction} />)}
          </div>
          <div className="sample-zones__bottom-btn">
            <CustomBtn
              label={translate.formatMessage({ id: 'fieldAgents.assignAllToFA' })}
              disabled={isDisabledAction}
              handleClick={() => {
                const resultGetAllZones = getAllZones(projectData);
                setSimpleZoneInfo(resultGetAllZones);
                setAssignAgentPopUp(!assignAgentPopUp);
              }}
            />
            <CustomBtn
              label={translate.formatMessage({ id: 'fieldAgents.assignRemainingSamplePlots' })}
              disabled={isDisabledAction}
              handleClick={() => {
                const resultGetRemainingZones = getRemainingZones(projectData);
                setSimpleZoneInfo(resultGetRemainingZones);
                setAssignAgentPopUp(!assignAgentPopUp);
              }}
            />
            <CustomBtn
              label={translate.formatMessage({ id: 'popUp.fieldAgents.delete.all' })}
              customClass="btn__fa-assign remove"
              disabled={isDisabledAction || !projectData.sampleZones.some((i) => i.field_agent_name)}
              handleClick={() => {
                setDeleteInfo({
                  idProject: projectData.project_id,
                  sample_zone_id: '',
                  all: true,
                });
                setDeleteAgentPopUp(!deleteAgentPopUp);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="project__field-noSimplePlots">
          <p>{translate.formatMessage({ id: 'fieldAgents.noSimplePlots' })}</p>
        </div>
      )}
      {assignAgentPopUp ? (
        <AssignAgentPopUp
          showPopUp={assignAgentPopUp}
          setShowPopUp={setAssignAgentPopUp}
          simpleZoneInfo={simpleZoneInfo}
        />
      ) : null}
      {deleteAgentPopUp ? (
        <DeleteFieldAgent
          showPopUp={deleteAgentPopUp}
          setShowPopUp={setDeleteAgentPopUp}
          deleteInfo={deleteInfo}
        />
      ) : null}
    </>
  );
};

export default ProjectFieldAgents;
